import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { BreadcrumbService } from '../../../@core/services/breadcrumb.service';
import { TextCasePipe } from '../../pipes/textCase.pipe';

@Component({
    selector: 'app-breadcrumb',
    standalone: true,
    imports: [CommonModule, BreadcrumbModule],
    providers: [TextCasePipe],
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
    items: MenuItem[] = [];
    home: MenuItem = { icon: 'pi pi-home', routerLink: '/' };

    private breadcrumbService = inject(BreadcrumbService);

    ngOnInit() {
        this.breadcrumbService.breadcrumbs.subscribe(breadcrumbs => {
            this.items = breadcrumbs.map(breadcrumb => ({
                label: breadcrumb.label,
                routerLink: breadcrumb.url
            }));
        });
    }
}


